import {
	Button,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Fab,
	WithStyles,
} from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IMessage } from 'src/actions/message';
import MessageDialog from 'src/components/MessageDialog';
import Progress from 'src/components/Progress';
import { IRootState } from 'src/reducers';
import { Routes, Screens } from 'src/utils/Routes';
import * as Actions from '../actions/quickModeContens';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IContentsTextInfo,
	ICourseInfo,
} from '../scenario/QuickModeContentsScenarioFactory';
import QuickModeIndexTree from './QuickModeIndexTree';
import QuickModePreviewBar from './QuickModePreviewBar';
import QuickModeTestPreview from './QuickModeTestPreview';
import QuickModeTextPreview from './QuickModeTextPreview';
const styles = (theme: Theme) =>
	createStyles({
		button1: {
			'&:hover': {
				backgroundColor: 'grey',
			},
			backgroundColor: 'darkgrey',
			borderRadius: '5px',
			fontSize: '1rem',
			height: '47px',
			lineHeight: '1.2',
			marginBottom: '5px',
			width: '100%',
		},
		button2: {
			'&:hover': {
				backgroundColor: '#c1c130',
			},
			backgroundColor: '#d1d11f',
			borderRadius: '5px',
			fontSize: '1rem',
			height: '47px',
			lineHeight: '1.2',
			marginBottom: '5px',
			width: '100%',
		},
		button3: {
			'&:hover': {
				backgroundColor: '#5c9128',
			},
			backgroundColor: '#6fb727',
			borderRadius: '5px',
			fontSize: '1rem',
			height: '47px',
			lineHeight: '1.2',
			marginBottom: '5px',
			width: '100%',
		},
		buttonBack: {
			bottom: theme.spacing(2),
			left: theme.spacing(2),
			position: 'fixed',
		},
		buttonForward: {
			bottom: theme.spacing(2),
			position: 'fixed',
			right: theme.spacing(2),
		},
		dialog: {
			width: '330px',
		},
		dialogContent: {
			textAlign: 'center',
		},
		dialogContentText: {
			textAlign: 'center',
		},
		root: {
			backgroundColor: '#fff',
			transition: 'width 2s',
		},
	});

interface IState {
	confirmDialog: boolean;
	exportResultDialog: boolean;
	messages: IMessage[];
	openDialog: boolean;
	loading: boolean;
	redirect: boolean;
	resultOK: boolean;
}

class QuickModeContensPreview extends React.Component<IProps, IState> {
	protected uploadInput: React.RefObject<HTMLInputElement>;
	protected quickTestForm: any;
	public constructor(props: IProps) {
		super(props);
		this.state = {
			confirmDialog: false,
			exportResultDialog: false,
			loading: false,
			messages: [],
			openDialog: false,
			redirect: true,
			resultOK: false,
		};
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.exportResultDialogClose = this.exportResultDialogClose.bind(this);
		this.handleNextQuestion = this.handleNextQuestion.bind(this);
		this.handlePrevQuestion = this.handlePrevQuestion.bind(this);
	}

	public componentDidMount() {
		if (this.props.text.length > 0) {
			this.props.setCurrentItem('TEXT', 0);
		} else if (this.props.test) {
			this.props.setCurrentItem('TEST', 0);
		}
	}

	public render() {
		const { classes, currentItem } = this.props;
		let main: JSX.Element | null = null;
		if (currentItem) {
			if (currentItem.kind === 'TEXT') {
				main = <QuickModeTextPreview />;
			}
			if (currentItem.kind === 'TEST') {
				main = (
					<QuickModeTestPreview
						handlePrev={this.handleBack}
						handleNext={this.handleNext}
						onRef={this.onRef}
						updateState={this.updateState}
					/>
				);
			}
			main = (
				<>
					{main}
					<Fab
						color="primary"
						aria-label="left"
						className={classes.buttonBack}
						onClick={this.handlePrevQuestion}
						disabled={!this.isValidPrev()}
					>
						<ArrowBackIcon />
					</Fab>
					<Fab
						color="primary"
						aria-label="right"
						className={classes.buttonForward}
						onClick={this.handleNextQuestion}
					>
						<ArrowForwardIcon />
					</Fab>
				</>
			);
		}
		return (
			<div className={classes.root}>
				<Progress open={this.state.loading} />
				<QuickModeIndexTree />
				<QuickModePreviewBar />
				{main}
				<this.Dialogs />
				<MessageDialog
					open={this.state.openDialog}
					showCancelButton={false}
					title={i18n.t('QuickModeContentsPreview_0000')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
				<MessageDialog
					open={this.state.exportResultDialog}
					showCancelButton={false}
					title={
						this.state.resultOK
							? i18n.t('QuickModeContentsPreview_0008')
							: i18n.t('QuickModeContentsPreview_0000')
					}
					contents={this.state.messages}
					onClose={this.exportResultDialogClose}
					onClickOk={this.exportResultDialogClose}
				/>
			</div>
		);
	}

	public handleBack = () => {
		const { currentItem } = this.props;
		if (!currentItem) {
			return;
		}
		if (currentItem.kind === 'TEXT') {
			const prepage = currentItem.page - 1;
			if (prepage > -1) {
				this.props.setCurrentItem('TEXT', prepage);
			}
		} else if (currentItem.kind === 'TEST') {
			this.props.setCurrentItem('TEXT', 0);
		}
	};

	public handleNext = () => {
		const { currentItem, text } = this.props;
		const textpages = text.length;
		if (!currentItem) {
			return;
		}
		if (currentItem.kind === 'TEXT') {
			const nextpage = currentItem.page + 1;
			if (nextpage < textpages) {
				this.props.setCurrentItem('TEXT', nextpage);
			} else {
				if (this.props.test) {
					this.props.setCurrentItem('TEST', 0);
				} else {
					this.setState({
						confirmDialog: true,
					});
				}
			}
		} else if (currentItem.kind === 'TEST') {
			this.setState({
				confirmDialog: true,
			});
		}
	};

	protected onRef = (view: object) => {
		this.quickTestForm = view;
	};

	protected updateState = () => {
		this.setState({});
	};

	protected handleNextQuestion = () => {
		const { currentItem } = this.props;
		if (!currentItem) {
			return;
		}
		if (currentItem.kind === 'TEST') {
			this.quickTestForm.handleNext();
			this.setState({});
		} else {
			this.handleNext();
		}
	};

	protected handlePrevQuestion = () => {
		const { currentItem } = this.props;
		if (!currentItem) {
			return;
		}
		if (currentItem.kind === 'TEST') {
			this.quickTestForm.handlePrev();
			this.setState({});
		} else {
			this.handleBack();
		}
	};

	protected Dialogs: React.SFC = props => {
		const { classes } = this.props;
		return (
			<>
				<Dialog
					fullScreen={false}
					fullWidth={true}
					maxWidth={false}
					open={this.state.confirmDialog}
					onClose={this.handleCloseConfirm}
					aria-labelledby="simple-dialog-title"
					classes={{
						paperFullWidth: this.props.classes.dialog,
					}}
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('QuickModeContentsPreview_0001')}
					</DialogTitle>
					<DialogContent className={classes.dialogContent}>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('QuickModeContentsPreview_0002')}
						</DialogContentText>
						<Button
							color="primary"
							variant="contained"
							className={classes.button1}
							onClick={this.handleOpenTree}
						>
							{i18n.t('QuickModeContentsPreview_0003')}
						</Button>
						<Button
							color="primary"
							variant="contained"
							className={classes.button2}
							onClick={this.handleBacktoCreate}
						>
							{i18n.t('QuickModeContentsPreview_0004')}
						</Button>
						<Button
							color="primary"
							variant="contained"
							className={classes.button3}
							onClick={this.exportCourse}
						>
							{i18n.t('QuickModeContentsPreview_0005')}
						</Button>
					</DialogContent>
				</Dialog>
			</>
		);
	};

	protected errorMessageDialogClose() {
		this.setState({ openDialog: false, messages: [] });
	}

	protected exportResultDialogClose() {
		this.setState({
			exportResultDialog: false,
			messages: [],
			openDialog: false,
			resultOK: false,
		});
		if (this.state.redirect) {
			const to = Routes.getPath(Screens.QUICK_MODE_CONTENTS_CREATE);
			this.props.pushHistory(to);
			this.props.reSetCurrentItem();
		} else {
			const to = Routes.getPath(Screens.QUICK_MODE_TEXT_TEST_CREATE);
			const state = {
				initFlg: true,
			};
			this.props.pushHistoryState(to, state);
			this.props.reSetCurrentItem();
		}
		this.setState({
			redirect: true,
		});
	}

	protected contentsCheck(preview: boolean) {
		const { text, test } = this.props;
		const viewItem: string[] = this.props.viewItem;
		const messages: IMessage[] = [];
		if (viewItem.length === 2) {
			if (text.length === 0 && test === null) {
				// 取込ファイルをアップロードしてください。
				const message: IMessage = {
					content: 'CHK_E_0042',
					replacements: [],
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
				return false;
			}
			if (text.length === 0 && test !== null) {
				if (preview) {
					return true;
				}
				// テキストの取込ファイルをアップロードしてください。
				const message: IMessage = {
					content: 'CHK_E_0041',
					replacements: [i18n.t('QuickModeContentsPreview_0006')],
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
				return false;
			}
			if (text.length !== 0 && test === null) {
				if (preview) {
					return true;
				}
				// テストの取込ファイルをアップロードしてください。
				const message: IMessage = {
					content: 'CHK_E_0041',
					replacements: [i18n.t('QuickModeContentsPreview_0007')],
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
				return false;
			}
		} else {
			if (viewItem.includes('TEXT')) {
				if (text.length === 0) {
					// テキストの取込ファイルをアップロードしてください。
					const message: IMessage = {
						content: 'CHK_E_0041',
						replacements: [i18n.t('QuickModeContentsPreview_0006')],
					};
					messages.push(message);
					this.setState({
						messages,
						openDialog: true,
					});
					return false;
				}
			} else if (viewItem.includes('TEST')) {
				if (test === null) {
					// テストの取込ファイルをアップロードしてください。
					const message: IMessage = {
						content: 'CHK_E_0041',
						replacements: [i18n.t('QuickModeContentsPreview_0007')],
					};
					messages.push(message);
					this.setState({
						messages,
						openDialog: true,
					});
					return false;
				}
			}
		}
		return true;
	}

	protected exportCourse = () => {
		if (!this.contentsCheck(false)) {
			return;
		}
		const viewItem: string[] = this.props.viewItem;
		const textList: IContentsTextInfo[] = [];
		let testModel: Actions.ITestInfo | null = null;
		if (viewItem.includes('TEXT')) {
			if (this.props.text.length > 0) {
				this.props.text.forEach(item => {
					const text = {
						fileName: item.htmlFile.fileName,
						filePath: item.htmlFile.filePath,
						resourceFolder: item.htmlFile.resourceFolder,
					};
					textList.push(text);
				});
			}
		}
		if (viewItem.includes('TEST')) {
			if (this.props.test !== null) {
				testModel = this.props.test;
			}
		}
		const param = {
			courseFolder: this.props.courseFolder,
			courseName: this.props.courseName,
			orgId: this.props.orgId,
			testModel,
			textList,
		};
		this.setState({
			loading: true,
		});
		this.props.createExportCourse(this.props.token, param).then(data => {
			this.setState({
				loading: false,
			});
			const messages: IMessage[] = [];
			if (data) {
				if (data.messageId === 'LMCM_E_00048') {
					const message: IMessage = {
						content: 'LMCM_E_00048',
						replacements: [],
					};
					messages.push(message);
					this.setState({
						exportResultDialog: true,
						messages,
						redirect: false,
					});
				} else {
					if (data.status === '0') {
						// コンテンツを作成しました。
						const message: IMessage = {
							content: 'LMCM_E_16027',
							replacements: [],
						};
						messages.push(message);
						this.setState({
							exportResultDialog: true,
							messages,
							resultOK: true,
						});
					} else if (data.status === '1') {
						// コンテンツの登録に失敗しました。
						const message: IMessage = {
							content: 'LMCM_E_16028',
							replacements: [],
						};
						messages.push(message);
						this.setState({
							exportResultDialog: true,
							messages,
						});
					}
				}
			} else {
				const to = Routes.getPath(Screens.QUICK_MODE_CONTENTS_CREATE);
				this.props.pushHistory(to);
			}
		});
	};

	protected handleOpenTree = () => {
		this.setState({ confirmDialog: false });
		this.props.openIndexTree();
	};

	protected handleBacktoCreate = () => {
		this.setState({ confirmDialog: false });
		const to = Routes.getPath(Screens.QUICK_MODE_TEXT_TEST_CREATE);
		const state = {
			initFlg: true,
		};
		this.props.reSetCurrentItem();
		this.props.pushHistoryState(to, state);
	};

	protected handleCloseConfirm = () => {
		this.setState({ confirmDialog: false });
	};

	protected isValidPrev() {
		const { currentItem, text } = this.props;
		if (!currentItem) {
			return;
		}
		if (currentItem.kind === 'TEXT') {
			if (currentItem.page === 0) {
				return false;
			}
			if (currentItem.page < text.length) {
				return true;
			}
		}
		if (currentItem.kind === 'TEST' && this.quickTestForm !== undefined) {
			if (currentItem.page === 0 && !this.quickTestForm.preBtnDisabled) {
				return true;
			}
		}
		if (currentItem.kind === 'TEST') {
			if (text.length > 0) {
				return true;
			}
		}
		return false;
	}
}
const mapStateToProps = (state: IRootState) => ({
	courseFolder: state.quickModeContents.courseFolder,
	courseName: state.quickModeContents.courseName,
	currentItem: state.quickModeContents.currentItem,
	orgId: state.quickModeContents.orgId,
	test: state.quickModeContents.test,
	text: state.quickModeContents.text,
	token: state.session.token,
	userAttr: state.session.userAttr,
	viewItem: state.quickModeContents.viewItem,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	createExportCourse: (token: string, param: ICourseInfo) => {
		const s = ScenarioFactory.createExportCourse(dispatch, token);
		return s.run(param);
	},
	openIndexTree: () => {
		dispatch(Actions.setIndexTree({}));
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	reSetCurrentItem: () => {
		dispatch(Actions.reSetCurrentItem({}));
	},
	setCurrentItem: (kind: string, page: number) => {
		dispatch(Actions.setCurrentItem({ kind, page }));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeContensPreview);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeContentsPreview.tsx